function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "noun_Twitter_2072457",
  transform: "translate(-27.000000, 0.000000)"
}, React.createElement("path", {
  d: "M60.68,0.4 C63.3963908,0.396160594 65.9928257,1.51859096 67.851,3.5 C70.051373,3.06683946 72.1614577,2.26054969 74.09,1.116 C73.3571145,3.39180054 71.8217251,5.32347672 69.77,6.551 C71.7176963,6.32000946 73.6198025,5.79855663 75.413,5.004 C74.0948625,6.97703162 72.4355767,8.69930263 70.513,10.09 C70.5316667,10.5113333 70.541,10.935 70.541,11.361 C70.541,24.344 60.659,39.314 42.588,39.314 C37.248329,39.3190879 32.0200977,37.7867231 27.528,34.9 C28.3059762,34.9915311 29.0886579,35.0372766 29.872,35.037 C34.2953804,35.0434821 38.5924008,33.5620667 42.072,30.831 C37.8688666,30.7519283 34.180707,28.0101204 32.894,24.008 C34.3665073,24.2904614 35.884068,24.2330014 37.331,23.84 C32.7465216,22.9126218 29.4504036,18.8833361 29.45,14.206 C29.45,14.165 29.45,14.124 29.45,14.083 C30.8133572,14.8445602 32.3392033,15.2687111 33.9,15.32 C29.5817339,12.4352154 28.2501735,6.69037065 30.859,2.2 C35.8480682,8.33828644 43.2088115,12.0695472 51.109,12.465 C50.4313985,9.54426117 51.1222879,6.47393617 52.9856853,4.12497694 C54.8490826,1.77601771 57.6816943,0.404691784 60.68,0.4 L60.68,0.4 Z",
  id: "Shape"
})));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "49px",
    height: "40px",
    viewBox: "0 0 49 40",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.329891c1.svg";
export { ForwardRef as ReactComponent };